<!--Transfer accounts-->
<lms-modal #agentsSelector size="medium">
  <div class="gl-popup__close" (click)="agentsSelector.close()">
    <span class="glicon-close"></span>
  </div>
  <div
    class="gl-popup__title"
    [innerHTML]="'agents.transferAgentAccountsTitle' | translate : '{ role:\'' + roleName + '\'}'"
  ></div>
  <div
    class="gl-popup__text"
    [innerHTML]="'agents.transferAgentAccountsMessage' | translate : '{ agent:\'' + agent.email + '\'}'"
  ></div>
  <div class="margin-top" *ngFor="let result of results">
    <div
      class="gl-popup__text"
      *ngIf="result.done"
      [innerHTML]="'agents.transferAgentAccountsSuccess' | translate : result"
    ></div>
    <div
      class="gl-popup__text"
      *ngIf="!result.done"
      class="error-text"
      [innerHTML]="'agents.transferAgentAccountsError' | translate : result"
    ></div>
  </div>
  <div class="margin-top">
    <lms-dynamic-form
      [action]="'agents.transferAccounts'"
      [questions]="questions"
      (submit)="transferAccounts($event)"
      [options]="{ disableCard: true }"
    >
      <gl-button
        color-secondary
        [text]="'actions.cancel' | translate"
        (onClick)="agentsSelector.close()"
        form-actions-before
      ></gl-button>
    </lms-dynamic-form>
  </div>
</lms-modal>
